import type { FC } from 'react';
import TableOfContents from 'components/03-organisms/TableOfContents';
import { useTailwindBreakpoint } from 'hooks/useTailwindBreakpoint';
import { TableOfContentsSectionData } from 'types';

type CourseWrapperProps = {
  toc: TableOfContentsSectionData[];
};

const CourseWrapper: FC<CourseWrapperProps> = ({ children, toc }) => {
  const { isScreenWiderOrEqualTo } = useTailwindBreakpoint();

  return (
    <main className="mx-auto narrow-x:container narrow-x:flex narrow-x:space-x-12">
      {toc && (
        <>
          <div className="flex-auto overflow-hidden pt-0 narrow-x:mx-5 narrow-x:pt-4">
            {children}
          </div>

          {isScreenWiderOrEqualTo('wide') && (
            <TableOfContents
              toc={toc}
              classes="w-[290px] self-start pb-64 flex-none sticky top-0"
            />
          )}
        </>
      )}
    </main>
  );
};

export default CourseWrapper;
